export default __webpack_public_path__ + "static/media/dashboard-dark.0c195e64.webp";